import { defineComponent } from '~/scripts/utils/alpine'

// This component should be attached to the SECTION element
export default defineComponent(() => ({
  // State
  isIntersecting: false,
  rafId: undefined as number | undefined,
  currentLeft: -25, // Initial position matches startLeft

  // Configuration (can be overridden via x-data options if needed)
  startLeft: -25, // Starting left position in rem
  totalTravel: 20, // Total horizontal travel in rem
  targetRef: 'svgContainer', // Default x-ref name for the element to animate

  // --- Methods called by x-intersect on the section ---
  startAnimation() {
    this.isIntersecting = true
    if (!this.rafId) {
      this.updatePosition()
    }
  },

  stopAnimation() {
    this.isIntersecting = false
    if (this.rafId) {
      cancelAnimationFrame(this.rafId)
      this.rafId = undefined
    }
  },

  // --- Animation Loop ---
  updatePosition() {
    if (!this.isIntersecting) {
      this.rafId = undefined
      return
    }

    // Get the element to animate using the ref name
    const targetElement = this.$refs[this.targetRef] as HTMLElement | undefined
    if (!targetElement) {
      console.warn(
        `ScrollEffectController: Element with x-ref="${this.targetRef}" not found.`,
      )
      this.stopAnimation() // Stop if target is missing
      return
    }

    const rect = targetElement.getBoundingClientRect()
    const viewportHeight = window.innerHeight
    const elementCenterY = rect.top + rect.height / 2
    const normProgress = Math.max(
      0,
      Math.min(1, (viewportHeight - elementCenterY) / viewportHeight),
    )

    // Calculate and update the reactive currentLeft property
    this.currentLeft = this.startLeft + this.totalTravel * normProgress

    // Style is applied via :style binding in the template

    // Request next frame
    this.rafId = requestAnimationFrame(() => this.updatePosition())
  },

  // --- Alpine Init ---
  init() {
    // No IntersectionObserver needed here anymore.
    // Ensure animation stops if component context is destroyed (e.g., navigating away)
    // Note: This assumes a mechanism like $store.app.destroying exists in your setup.
    // If not, standard Alpine cleanup might suffice depending on app structure.
    // this.$watch('$store.app.destroying', () => this.stopAnimation())
    // Set initial position without waiting for intersection
    // This is handled by the initial value of currentLeft and the :style binding
  },
}))
